import React, { useEffect, useState } from "react";
import SwotColumn from "./SwotColumn";
import { useDispatch, useSelector } from "react-redux";
import opportunitySVG from "../../images/SWOT/opportunity.svg";
import threatSVG from "../../images/SWOT/threat.svg";
import weaknessSVG from "../../images/SWOT/weakness.svg";
import strengthSVG from "../../images/SWOT/strength.svg";
import styled from "styled-components";
import { CLEAR_SWOT_ITEM } from "./one-swot-item/actionTypes";

const Swot = ({ entity, fromCoach, adjust}) => {
  const { name: axisName, swots: axisSwot } = useSelector(
    (state) => state.oneAxis
  );
  const {
    name: projectName,
    comment: projectComment,
    swot: projectSwot,
  } = useSelector((state) => state.project);
  const { swot: strategySwot } = useSelector((state) => state.strategy);

  const [strengthItem, setStrengthItem] = useState([]);
  const [weaknessItem, setWeaknessItem] = useState([]);
  const [opportunityItem, setOpportunityItem] = useState([]);
  const [threatItem, setThreatItem] = useState([]);

  useEffect(() => {
    let swot = [];
    if (entity === "axis") {
      swot = axisSwot;
    }
    if (entity === "project") {
      swot = projectSwot;
    }
    if (entity === "strategy") {
      swot = strategySwot;
    }
    if (swot) {
      setStrengthItem(swot.filter((item) => item.type === "strength"));
      setWeaknessItem(swot.filter((item) => item.type === "weakness"));
      setOpportunityItem(swot.filter((item) => item.type === "opportunity"));
      setThreatItem(swot.filter((item) => item.type === "threat"));
    }
  }, [axisName, axisSwot, entity, projectName, projectSwot, strategySwot]);

  const { hasFailed, isSend } = useSelector((state) => state.oneSwotItem);
  const dispatch = useDispatch();

  useEffect(() => {
    if (hasFailed || isSend) {
      setTimeout(() => {
        dispatch({ type: CLEAR_SWOT_ITEM });
      }, 5000);
    }
  }, [dispatch, hasFailed, isSend]);

  const columns = [
    {
      id: 1,
      name: "Forces",
      icon: strengthSVG,
      type: "strength",
      items: strengthItem,
    },
    {
      id: 2,
      name: "Faiblesses",
      icon: weaknessSVG,
      type: "weakness",
      items: weaknessItem,
    },
    {
      id: 3,
      name: "Opportunités",
      icon: opportunitySVG,
      type: "opportunity",
      items: opportunityItem,
    },
    {
      id: 4,
      name: "Menaces",
      icon: threatSVG,
      type: "threat",
      items: threatItem,
    },
  ];

  return (
    <Container>
      <Columns>
        {columns.map((column) => (
          <SwotColumn
            key={column.id}
            id={column.id}
            name={column.name}
            icon={column.icon}
            type={column.type}
            items={column.items}
            entity={entity}
            entityName={
              entity === "axis"
                ? axisName
                : entity === "project"
                ? projectName
                : ""
            }
            entityComment={entity === "project" ? projectComment : ""}
            fromCoach={fromCoach}
            adjust={adjust}
          />
        ))}
      </Columns>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 100%;
`;

const Columns = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 1rem;
  overflow-x: hidden;
  height: 100%;
  @media (min-width: 768px) {
    display: grid;
    grid-template-columns: repeat(12, 1fr);
    grid-template-rows: repeat(4, 9rem);
  }
`;

export default Swot;
